(ns ballot-scout-v2-frontend.import-manager.subs
  (:require
   [ballot-scout-v2-frontend.import-manager.events :as e.import]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::upload
 (fn [db]
   (get-in db [e.import/ns-key :upload])))

(rf/reg-sub
 ::data
 (fn [db]
   (get-in db [e.import/ns-key :data])))

(rf/reg-sub
 ::fetch-import-status
 (fn [db]
   (get-in db [e.import/ns-key :fetching-import :status])))

(rf/reg-sub
 ::import-data
 :<- [::subs/current-import]
 :<- [::data]
 (fn [[import data]]
   (get data (:import/id import))))

(rf/reg-sub
 ::headers
 :<- [::subs/current-import]
 :<- [::import-data]
 (fn [[import import-data]]
   (when import
     (let [{:keys [status headers]} (:header-state import-data)]
       (when-not status
         (rf/dispatch [::e.import/fetch-headers import]))
       headers))))

(rf/reg-sub
 ::existing-voters-state
 :<- [::subs/current-import]
 :<- [::import-data]
 (fn [[import import-data]]
   (when import
     (let [{:keys [status] :as state} (:existing-voters-state import-data)]
       (when-not status
         (rf/dispatch [::e.import/fetch-existing-voter-rows import]))
       (when (= status :complete)
         state)))))

(rf/reg-sub
 ::invalid-rows-state
 :<- [::subs/current-import]
 :<- [::import-data]
 (fn [[import import-data]]
   (when import
     (let [{:keys [status] :as state} (:invalid-rows-state import-data)]
       (when-not status
         (rf/dispatch [::e.import/fetch-invalid-rows import]))
       (when (= status :complete)
         state)))))

(rf/reg-sub
 ::imports-list-state
 (fn [db]
   (get-in db [e.import/ns-key :imports-list-state])))

(defn phases [import]
  [{:phase :import-phase/upload-file
    :label "Upload File"}
   {:phase :import-phase/match-fields
    :label "Match Fields"}
   {:phase :import-phase/generate-imbs
    :label "Create IMbs"}
   {:phase :import-phase/reissue-ballots
    :label "Re-issue Ballots"}
   {:phase :import-phase/final
    :label (cond
             (:import/completed-ts import) "Import Completed!"
             (:import/started-ts import) "Import in Progress"
             :else "Ready to Import")}])

(rf/reg-sub
 ::current-import-phases
 :<- [::subs/current-import]
 (fn [import]
   (phases import)))
